<template>
  <el-dialog class="autotag-edit" :visible.sync="visible" :title="ruleForm.id ? '编辑' : '新增'" @closed="closed">
    <el-form ref="ruleForm" v-loading="loading" :model="ruleForm" class="form" :rules="rules" label-position="top">
      <div class="wrapper">
        <div class="form-container">
          <el-form-item label="公司名称" class="form-item required" prop="companyName">
            <el-input
              v-model.trim="ruleForm.companyName"
              size="small"
              placeholder="请输入公司名称"
              clearable
            />
          </el-form-item>
          <el-form-item v-if="ruleForm.id" label="管理员">
            <el-select v-model="ruleForm.userIdList" multiple filterable collapse-tags size="small" placeholder="请选择管理员">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <div class="form-btn">
              <el-button class="cancel-btn" @click="closed()">
                取 消
              </el-button>
              <el-button class="true-btn" @click="submitForm('ruleForm')">
                保 存
              </el-button>
            </div>
          </el-form-item>
        </div>
      </div>
    </el-form>
  </el-dialog>
</template>
<script>
import { addSysCompany, editSysCompany, userGetPage } from '@/api/index'
export default {
  data() {
    return {
      visible: false,
      loading: false,
      ruleForm: {
        companyName: '',
        id: '',
        userIdList: []
      },
      rules: {
        companyName: [
          { required: true, message: '请输入公司名称', trigger: 'change' }
        ]
      },
      companyIdList: [],
      options: []
    }
  },
  methods: {
    /**
     * 管理员列表
     * */
    getUserGetPage() {
      const data = {
        current: 1,
        size: 9999999,
        companyIdList: this.companyIdList
      }
      userGetPage(data).then((res) => {
        if (res.code === 0) {
          this.options = res.data.records.map(item => {
            return { label: item.nickName, value: item.userId }
          })
        }
      })
    },
    closed() {
      this.$refs['ruleForm'].resetFields()
      this.ruleForm.id = ''
      this.companyIdList = []
      this.visible = false
    },
    init(row) {
      this.visible = true
      this.$nextTick(() => { // 注意看这里
        if (row) {
          this.ruleForm.id = row.id
          this.ruleForm.companyName = row.companyName
          this.ruleForm.userIdList = row.adminUserList ? row.adminUserList.map(item => item.userId) : []
          this.companyIdList.push(this.ruleForm.id)
          this.getUserGetPage()
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.id) {
            this.getEditSysCompany()
          } else {
            this.getAddSysCompany()
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    /**
     * 新增子公司
     */
    getAddSysCompany() {
      this.loading = true
      const data = {
        ...this.ruleForm
      }
      addSysCompany(data).then((res) => {
        this.loading = false
        if (res.code === 0) {
          this.visible = false
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.$emit('fresh')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    /**
     * 编辑子公司
     */
    getEditSysCompany() {
      this.loading = true
      const data = {
        ...this.ruleForm
      }
      editSysCompany(data).then((res) => {
        this.loading = false
        this.visible = false
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.$emit('fresh')
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
  .wrapper {
    .form-container {
      width: 400px;
      margin: 0 auto;
      ::v-deep .el-form-item {
        margin-bottom: 14px;
        .el-form-item__label{
          padding-bottom: 0px;
          line-height: 26px;
        }
      }
      ::v-deep .el-select {
        width: 100%;
      }
      .head{
        width: 100%;
        margin-bottom: 18px;
        >span{
          color: #646A73;
          font-size: 14px;
        }
        >div{
          display: flex;
          display: -webkit-flex;
          flex-wrap: wrap;
          justify-content: space-between;
          margin-top: 8px;
          .headImage{
            display: flex;
            display: -webkit-flex;
            .el-image{
              width: 60px;
              height: 60px;
              border-radius: 4px;
              margin-right: 12px;
            }
            .upload{
              .upload__tip{
                color: #646A73;
                font-size: 12px;
                margin-bottom: 11px;
              }
            }
          }

          .tag-status{
            display: flex;
            display: -webkit-flex;
            justify-content: flex-end;
            >span{
              color: #8691A3;
              font-size: 16px;
              margin-right: 8px;
            }
            .tag-status-info{
              width: 67px;
              height: 24px;
              line-height: 24px;
              background: #E1EAFF;
              border-radius: 12px;
              display: flex;
              align-items: center;
              >img {
                width: 14px;
                height: 14px;
                margin-right: 8px;
                margin-left: 5px;
              }
              >span {
                font-size: 14px;
                font-weight: 400;
              }
            }
          }
        }
      }
      .form-btn {
        margin-top: 26px;
        display: flex;
        justify-content: flex-end;
        .cancel-btn {
          width: 66px;
          height: 32px;
          background: #FFFFFF;
          border-radius: 4px;
          border: 1px solid #DFE0E3;
          padding: 0px;
          font-size: 14px;
          font-weight: 400;
          color: #1F2329;
        }
        .true-btn {
          width: 66px;
          height: 32px;
          background: #3370FF;
          border-radius: 4px;
          padding: 0px;
          font-size: 14px;
          font-weight: 400;
          color: #FFFFFF;
          border: 1px solid #3370FF;
        }
      }
    }
  }
</style>
